// @ts-ignore
export const sidebar = (state) => state.sidebar;
